import { dataHooks } from '@wix/data-hooks';

export const onlineOrdersDataHooks = dataHooks<{
  root: {};
}>('online-orders');
